export var AuditType;
(function (AuditType) {
    AuditType["PATIENT_VIEW"] = "PATIENT_VIEW";
    AuditType["PATIENT_VIEW_NOT_FOUND"] = "PATIENT_VIEW_NOT_FOUND";
    AuditType["SCRIBE_LOGIN"] = "SCRIBE_LOGIN";
    AuditType["LIST_VIEW"] = "LIST_VIEW";
})(AuditType || (AuditType = {}));
